import React from 'react'
import PropTypes from 'prop-types'
import IconButton from '@material-ui/core/IconButton'

import Axios from '@components/Axios'
import Icon from '@components/Icon'
import Table from '@components/Table'

import './styles.scss'

const VideoList = ({ list = [], setItem, updateList }) => {
  const columns = [
    { title: 'DOWNLOAD_LIST_TITLE', field: 'title' },
    { title: 'DOWNLOAD_LIST_URL', field: 'archive' },
    { title: 'POST_LIST_PUBLISH',
      component: item => {
        let status = item.status === 'PUBLISHED' ? 'Publicado' : 'Rascunho'
        return (
          <>
            {status}
          </>
        )
      }
    },
    {
      title: 'VIDEO_LIST_OPTIONS',
      className: 'options',
      component: item => {
        return (
          <>
            <IconButton onClick={() => setItem(item)} className="list-edit">
              <Icon size={30} name="edit" />
            </IconButton>
            <Axios
              api="downloads"
              method="delete"
              others={item._id}
              onSuccess={updateList}
            >
              {({ submit }) => (
                <IconButton onClick={submit} className="list-delete">
                  <Icon size={30} name="delete_icon" />
                </IconButton>
              )}
            </Axios>
          </>
        )
      }
    }
  ]

  return (
    <div className="DownloadList">
      <Table data={list} columns={columns} title="DOWNLOAD_LIST_TABLE_TITLE" />
    </div>
  )
}

export default VideoList

VideoList.propTypes = {
  list: PropTypes.array,
  setItem: PropTypes.func,
  updateList: PropTypes.func
}
